import { getScoreColor } from "~/feature/warIndex/utils/getScoreColor";

const BAND_COLORS: Record<string, string> = {
  critical: "#E24B4A",
  "danger zone": "#E24B4A",
  elevated: "#EF9F27",
  watchful: "#97C459",
  moderate: "#97C459",
  calm: "#639922",
  low: "#639922",
};

export const getBandColor = (band: string, score?: number): string => {
  if (score != null && Number.isFinite(score)) {
    return getScoreColor(score);
  }

  const key = band.toLowerCase();
  return BAND_COLORS[key] ?? "#E24B4A";
};
